// Schreiben-Assistent (#586): Zustand aller Schritte. Schlüssel je Empfänger: `${art}:${id}`.
import type { BriefOptionen } from '../../../lib/epost/epost';
import type { WiedervorlageWahl } from '../../../lib/schreiben/wiedervorlage';
import type { SchreibenAnlage, SchreibenEmpfaenger, Zustellweg } from '../../../lib/schreiben/typen';

export interface Zustand {
  vorlageId: string | null;
  immerPost: boolean;
  begleittext: string;
  betreff: string;
  text: string;
  empfaenger: SchreibenEmpfaenger[];
  /** Eingabefelder ({{eingabe.k|…}}), für alle Empfänger gleich */
  eingaben: Record<string, string>;
  /** Je Empfänger überschriebene Werte ({{gruppe.feld}}) */
  werteNeu: Record<string, Record<string, string>>;
  /** #587: gewählte Wege je Empfänger (leer = nicht senden) */
  wege: Record<string, Zustellweg[]>;
  anlagen: SchreibenAnlage[];
  optionen: BriefOptionen;
  /** Etappe 2: Briefkopf (null = der der Vorlage bzw. Standard) und Absender (null = ohne) */
  briefkopfId: string | null;
  absenderId: string | null;
  /** Etappe 3: Schriftform (Original per Druck/Post, E-Mail/Portal nur vorab) – aus der Vorlage, im Versand umschaltbar */
  schriftform: boolean;
  /** Etappe 4: Vorbelegung der Vorlage (Tage, Vorgangsart) und die Wahl im Schritt Versand (null = noch nicht vorbelegt) */
  wiedervorlageTage: number | null;
  vorgangsartId: string | null;
  wiedervorlage: WiedervorlageWahl | null;
  /** Nach dem Senden gesetzt – derselbe Lauf darf nicht noch einmal raus */
  gesendetId: string | null;
}

export type SetZustand = (f: (z: Zustand) => Zustand) => void;

export const schluessel = (e: Pick<SchreibenEmpfaenger, 'art' | 'id'>) => `${e.art}:${e.id}`;

export const START: Zustand = {
  vorlageId: null, immerPost: false, begleittext: '', betreff: '',
  text: 'Sehr geehrte Damen und Herren,\n\n\n\nMit freundlichen Grüßen\n\nImmobilienmanagement Schwede',
  empfaenger: [], eingaben: {}, werteNeu: {}, wege: {}, anlagen: [], optionen: { farbe: false, duplex: false, einschreiben: '' }, briefkopfId: null, absenderId: null, schriftform: false, wiedervorlageTage: null, vorgangsartId: null, wiedervorlage: null, gesendetId: null,
};

/** Werte eines Empfängers inkl. Änderungen aus der Eingabeleiste. */
export const werteVon = (z: Pick<Zustand, 'werteNeu'>, e: SchreibenEmpfaenger) => ({ ...e.werte, ...(z.werteNeu[schluessel(e)] ?? {}) });
